// export const BASE_URL = `https://forsakringsgaranti.bravioz.com`;
export const BASE_URL = `https://forsakringsgaranti-intra.reaktive.eu`;
// export const BASE_URL = `http://localhost:4000`;